var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#171D38",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.476 5.984a2.25 2.25 0 1 0 4.047-1.968 2.25 2.25 0 0 0-4.047 1.968m0 0L6.442 8.375m0 0C6.121 7.729 5.48 7.25 4.5 7.25c-3 0-3 4.5 0 4.5.863 0 1.478-.418 1.832-.998m.11-2.377c.364.73.319 1.673-.11 2.377m0 0 5.033 2.498m0 0c-.416 1.309.296 3 2.135 3 3 0 3-4.5 0-4.5-1.16 0-1.873.674-2.135 1.5"
  })));
};
export default SvgShare;